import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  isProductEntity,
  isSolutionEntity,
} from '@ipen-portal/ipen-entity-model';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { tdhApiRef } from './apis';
import { ComplianceCard } from './components/ComplianceCard';
import { GdprAiGovernanceCard } from './components/GdprAiGovernanceCard';
import { LeanixInfoCard } from './components/LeanixInfoCard';

const LeanixRelationPickerFieldExtension = FormFieldBlueprint.make({
  name: 'LeanixRelationPicker',
  params: {
    field: () =>
      import('./scaffolder-extensions/LeanixRelationPicker').then(m =>
        createFormField({
          component: m.LeanixRelationPicker,
          name: 'LeanixRelationPicker',
          schema: m.LeanixRelationPickerFieldSchema,
        }),
      ),
  },
});

export const tdhPlugin = createFrontendPlugin({
  extensions: [
    LeanixRelationPickerFieldExtension,
    TrpcApiBlueprint.make({
      name: 'tdh-api',
      params: defineParams =>
        defineParams({
          apiRef: tdhApiRef,
          path: 'tdh-backend',
        }),
    }),
    EntityCardBlueprint.make({
      name: 'leanix-info',
      params: {
        filter: entity => isSolutionEntity(entity) || isProductEntity(entity),
        loader: async () => <LeanixInfoCard />,
        type: 'info',
      },
    }),
    EntityCardBlueprint.make({
      name: 'gdpr-ai-governance',
      params: {
        filter: entity => isSolutionEntity(entity) || isProductEntity(entity),
        loader: async () => <GdprAiGovernanceCard />,
      },
    }),
    EntityCardBlueprint.make({
      name: 'compliance',
      params: {
        filter: entity => isSolutionEntity(entity) || isProductEntity(entity),
        loader: async () => <ComplianceCard />,
      },
    }),
  ],
  pluginId: 'tdh',
});
